module.exports = __webpack_public_path__ + "img/cd.cd346cdc.svg";